import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser'

export default function isMsalExpiryError(
    error: unknown
): error is InteractionRequiredAuthError | BrowserAuthError {
    return error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError
}
